import React, {useEffect, useState} from 'react';
import styles from './Loader.module.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faRunning, faPersonRunning } from "@fortawesome/free-solid-svg-icons";
import TitleMain from "../Title/TitleMain";

const Loader = () => {

    return (
        <div className={styles.container}>
            <div className={styles.loader}>
                <TitleMain text="Chargement en cours..."/>
                <FontAwesomeIcon icon={faRunning} className={styles.icon}/>
                <FontAwesomeIcon icon={faPersonRunning} className={`${styles.icon} ${styles.iconShadow}`}/>
            </div>
        </div>
    );
};

export default Loader;
